import { Navigate } from 'react-router-dom'

/**
 * Admission Analytics is a report-only submodule matching legacy StudentAnalytics.aspx and navigation standards.
 * Any direct navigation to entry redirects smoothly to the live analytics dashboard.
 */
export default function AnalyticsEntryScreen() {
  return <Navigate to="/admission/analytics/list" replace />
}
